import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

// Loading placeholder for LifecyclePipeline.jsx — shape-matched to LifecycleRow.jsx's own
// card layout (icon square + title/count stack + two icon buttons), NOT the generic
// DashboardRowSkeleton (that one's circular-avatar+2-lines shape doesn't match this card).
function LifecycleRowSkeleton({ count = 4 }) {
  const theme = useTheme();
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            backgroundColor: theme.palette.mode === "light" ? theme.palette.background.default : theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "16px",
            p: 1.75,
            mb: 0.9,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Skeleton variant="rounded" width={28} height={28} sx={{ borderRadius: "8px", flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="45%" height={20} />
            <Skeleton variant="text" width={70} height={30} sx={{ mt: 0.25 }} />
          </Box>
          <Skeleton variant="circular" width={30} height={30} sx={{ flexShrink: 0 }} />
          <Skeleton variant="circular" width={28} height={28} sx={{ flexShrink: 0 }} />
        </Box>
      ))}
    </>
  );
}

export default LifecycleRowSkeleton;
